/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Jayd Saucedo
 * Date: 1/2/18
 * Copyright All Rights Reserved
 */
import React, { Component } from 'react';
import Header from 'components/Header';
import PropTypes from 'prop-types';
import MigrationBanner from 'components/MigrationBanner';
import NoReportsCTA from 'components/NoReportsCTA';
import ReportsTable from 'components/ReportsTable';
import SpinnerRect from 'components/SpinnerRect';

class ListPage extends Component {
  componentDidMount() {
    this.pollInterval = this.props.handleMount();
  }

  componentWillUnmount() {
    clearInterval(this.pollInterval);
  }

  buildTable() {
    return this.props.reports.length > 0 ?
      (<ReportsTable reports={this.props.reports} />) :
      (<NoReportsCTA />);
  }

  render() {
    const loader = (
      <div className="loading-alert alert text-center" role="alert">
        <strong>Loading Reports...</strong>
        <SpinnerRect className="center-block" />
      </div>
    );

    const content = this.props.loading ? loader : this.buildTable();

    return (
      <div className="app-page list-page">
        <Header />
        <div className="container  main-container">
          <MigrationBanner />
          <div className="row">
            <div className="col-md-12 page-name">
              View Reports
            </div>
          </div>
          {content}
        </div>
      </div>
    );
  }
}

ListPage.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool.isRequired,
  handleMount: PropTypes.func.isRequired,
};

export default ListPage;
